import { requests } from '../../helper/agent';
import { SubmissionError } from 'redux-form';
import {
  EMAIL_RESPONSE_LIST_REQUEST,
  EMAIL_RESPONSE_LIST_RECEIVED,
  EMAIL_RESPONSE_LIST_ERROR,
  EMAIL_RESPONSE_LIST_UNLOAD,
  EMAIL_RESPONSE_LIST_UNLOAD_PERSIST_FILTERS,
  EMAIL_RESPONSE_LIST_SET_PAGE,
  EMAIL_RESPONSE_LIST_SET_FILTERS,
  EMAIL_RESPONSE_LIST_CLEAR_FILTERS,
  EMAIL_RESPONSE_MARK_ACTIONED_REQUEST,
  EMAIL_RESPONSE_SINGLE_UPDATED,
} from '../constants';

import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { parseApiErrors } from '../../helper/apiUtils';

export const emailResponseListRequest = () => ({
  type: EMAIL_RESPONSE_LIST_REQUEST,
});

export const emailResponseMarkActionedRequest = () => ({
  type: EMAIL_RESPONSE_MARK_ACTIONED_REQUEST,
});

export const emailResponseSingleUpdated = (data) => ({
  type: EMAIL_RESPONSE_SINGLE_UPDATED,
  data,
});

export const emailResponseListError = (error) => ({
  type: EMAIL_RESPONSE_LIST_ERROR,
  error,
});

export const emailResponseListReceived = (data, append = false) => ({
  type: EMAIL_RESPONSE_LIST_RECEIVED,
  data,
  append,
});

export const emailResponseListUnload = (persistFilters = true, routeKey) => {
  if (persistFilters) {
    return {
      type: EMAIL_RESPONSE_LIST_UNLOAD_PERSIST_FILTERS,
      routeKey,
    };
  }
  return {
    type: EMAIL_RESPONSE_LIST_UNLOAD,
    routeKey,
  };
};

export const emailResponseListSetPage = (page) => ({
  type: EMAIL_RESPONSE_LIST_SET_PAGE,
  page,
});

export const emailResponseListSetFilters = (filters) => ({
  type: EMAIL_RESPONSE_LIST_SET_FILTERS,
  filters,
});

export const emailResponseListClearFilters = () => ({
  type: EMAIL_RESPONSE_LIST_CLEAR_FILTERS,
});

export const emailResponseListFetch = (page = 1, filters = {}, append = false) => {
  return (dispatch) => {
    dispatch(emailResponseListRequest());
    if (filters.pagination === undefined) {
      filters.pagination = true;
    }
    if (filters.pagination) {
      filters.page = page;
    }
    return requests
      .get(API_ROUTES.EMAIL_RESPONSES, filters)
      .then((response) => dispatch(emailResponseListReceived(response, append)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(emailResponseListError(error));
      });
  };
};

export const emailResponseMarkActioned = (id, actionNotes = '') => {
  return (dispatch) => {
    dispatch(emailResponseMarkActionedRequest());
    return requests
      .patch(API_ROUTES.EMAIL_RESPONSES + '/' + id, { isActioned: true, actionNotes }, true)
      .then((response) => dispatch(emailResponseSingleUpdated(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(emailResponseListError(error));
      });
  };
};
